import common from './api/common';
import image from './api/image';
import files from './api/files';
// category
import category from './api/category';
// 导出一个map
export default {
  common,
  image,
  category,
  files
};
